import React from 'react';
const bonuses = [{
  title: 'BIBLIOTECA DI ALLENAMENTI EXPRESS™',
  description: 'Allenamenti completi da 30, 45 e 60 minuti già pronti, ideali per preparare qualsiasi lezione in pochissimo tempo.'
}, {
  title: 'MANUALE DI PREVENZIONE DEGLI INFORTUNI™',
  description: 'Routine di riscaldamento, mobilità, stabilità, forza preventiva e checklist di sicurezza per ridurre il rischio di infortuni.'
}, {
  title: "KIT DI VALUTAZIONE DELL'ATLETA™",
  description: 'Schede professionali, test tecnici, strumenti di monitoraggio e modelli pronti per seguire i progressi dei ginnasti.'
}, {
  title: 'PROGRAMMI STAGIONALI PRONTI™',
  description: 'Pianificazioni complete di 4, 8 e 12 settimane con obiettivi, progressioni e allenamenti già organizzati.'
}, {
  title: 'COACH ORGANIZATION TOOLKIT™',
  description: 'Planner, registri, checklist, modelli organizzativi e strumenti pratici per gestire gruppi, atleti e allenamenti in modo professionale.'
}];
export function BonusSection() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-ivory" data-id="element-24">
      <div className="text-center mb-6" data-id="element-25">
        <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-brand-navy mb-2 uppercase leading-tight" data-id="element-26">
          🎁 In Più Riceverai 5 Bonus Esclusivi
        </h2>
      </div>

      <div className="flex flex-col gap-3" data-id="element-27">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold/50 p-4 rounded-lg text-center shadow-sm" data-id="element-28">
            <p className="text-xs font-heading font-bold text-brand-gold mb-1 tracking-wider uppercase" data-id="element-29">
              🎁 Bonus {i + 1}
            </p>
            <h3 className="text-base font-heading font-bold text-brand-navy mb-1.5 leading-tight uppercase" data-id="element-30">
              {bonus.title}
            </h3>
            <p className="text-sm text-brand-text font-medium leading-relaxed" data-id="element-31">
              {bonus.description}
            </p>
          </div>)}
      </div>
    </section>;
}